const KeyboardSlide = {
    beforeMount(el, binding, vnode) {
        alert("Mounted")
        const vm = vnode.context
        window.addEventListener('keydown', l = (e) => {
            e.code == 'ArrowRight' ? vm.$refs.next.click() : false
            e.code == 'ArrowLeft' ? vm.$refs.previous.click() : false
        })
    },
    beforeUnmount(el, binding, vnode) {
        window.removeEventListener('keydown', l)
    }
}

export default { KeyboardSlide }